import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "suitcase",
  "use": "suitcase-usage",
  "viewBox": "0 0 17.75 15.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.75 15.75\" id=\"suitcase\">\n  <path fill-rule=\"evenodd\" d=\"M48.444,473.937V472.25a1.118,1.118,0,0,0-1.111-1.125H40.667a1.118,1.118,0,0,0-1.111,1.125v1.687H36.222a1.118,1.118,0,0,0-1.111,1.125V485.75a1.118,1.118,0,0,0,1.111,1.125H51.778a1.118,1.118,0,0,0,1.111-1.125V475.062a1.118,1.118,0,0,0-1.111-1.125H48.444Zm-7.222-1.125h5.556v1.125H41.222v-1.125Zm10,2.813V479H45.667v-0.563H42.333V479H36.778v-3.375H51.222Zm-14.444,9.562v-4.5h5.556v0.563h3.333v-0.563h5.556v4.5H36.778Z\" transform=\"translate(-35.125 -471.125)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/suitcase.svg
// module id = null
// module chunks = 